//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import PageBanner from '../PageBanner.vue';
import PageLimiter from '../PageLimiter.vue';
import Breadcrumbs from '../Breadcrumbs.vue';
import BtnBack from '../BtnBack.vue';
import PostMeta from '../PostMeta.vue';
import PostSocial from '../PostSocial.vue';
import VideoBox from '../VideoBox.vue';

export default {
	name: 'PageNewsInner',

	components: { PageBanner: PageBanner, PageLimiter: PageLimiter, Breadcrumbs: Breadcrumbs, BtnBack: BtnBack, PostMeta: PostMeta, PostSocial: PostSocial, VideoBox: VideoBox },

	props: {
		page: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		content: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		crumbs: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},

	computed: {
		media: function media() {
			return this.content.media || [];
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageNewsInner.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageNewsInner.vue
// module chunks = 1 2